import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initTheme } from './hooks/useTheme';
import { BRAND_NAME } from './lib/brand';
import { initTma } from './lib/tma';
import './styles/index.css';

initTma();
initTheme();
document.title = BRAND_NAME;

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
